import React, {useEffect} from 'react';
import {
  setLocalChallenges,
  setLocalCompletions,
  setLocalCompletionsList,
  setLocalFavorites,
  setLocalLeaderboard,
  setLocalLocations,
  setLocalLocationsList,
  setLocationTagTypes,
} from '../Redux/reducers/local.reducer';
import {useDispatch, useSelector} from 'react-redux';

import {View} from 'react-native';
import {apiGetLocalGuide} from '../Utils/apiCalls';
import {orderLocationListByDistanceAway} from '../Utils/distanceHelpers';
import {useQuery} from '@tanstack/react-query';
import {useUserId} from '../Hooks/reduxHooks';

const LocalController = () => {
  const localLocations = useSelector((state) => state.local.localLocations);

  const userId = useUserId();

  const localFilters = useSelector((state) => state.local.localFilters);

  const roundedRegion = useSelector(
    (state) => state.location.roundedRegion || {},
  );
  const {latitude: roundedLat, longitude: roundedLong} = roundedRegion;

  const queryKey =
    'allLocaldata, ui:' +
    userId +
    ',lat:' +
    Math.round(roundedLat) +
    ', long:' +
    Math.round(roundedLong);

  console.log('LocalController', {queryKey, roundedRegion});

  const dispatch = useDispatch();
  const {data, refetch} = useQuery([queryKey], async () => {
    console.log('apiGetLocalGuide fired');
    // /api/v1/get_local_guide_info_all
    const localGuideAPIResponse = await apiGetLocalGuide({
      get_all: 1,
      userId,
      roundedLat,
      roundedLong,
    });

    // console.log({localGuideAPIResponse});

    console.log('pulling query data', {queryKey});
    if (!localGuideAPIResponse) {
      console.error('apiGetLocalGuide failed');
      throw new Error('no local locations');
    } else {
      console.log('apiGetLocalGuide succeeded');
    }
    return localGuideAPIResponse;
  });

  useEffect(() => {
    global.localDataRefetch = refetch;
    // console.log({localDataRefetch: window.localDataRefetch});
  }, [refetch]);

  useEffect(() => {
    if (data?.locations) {
      const newLocalLocations = {};
      data?.locations?.map?.((location) => {
        const newLocation = {...location};
        if (newLocation.tag_ids && typeof newLocation.tag_ids == 'string') {
          // console.log({tag_ids: newLocation.tag_ids});
          try {
            newLocation.tag_ids = JSON.parse(newLocation.tag_ids || '[]');
            newLocation.photo = newLocation.photo?.replace(
              './',
              'https://photos.letsroam.com/',
            );
          } catch (parseError) {
            console.log({parseError});
            newLocation.tag_ids = [];
          }
        }
        newLocalLocations[newLocation.id] = newLocation;
      });
      dispatch(setLocalLocations(newLocalLocations));

      dispatch(setLocationTagTypes(data?.locationTagTypes));

      // Alert.alert('favorites', JSON.stringify(data?.favorites));

      dispatch(setLocalFavorites(data?.favorites));

      if (data?.leaderboard) {
        dispatch(setLocalLeaderboard(data?.leaderboard));
      }

      if (data?.localCompletions) {
        // Alert.alert(JSON.stringify(data?.localCompletions));
        const newLocalCompletions = {};
        data?.localCompletions?.map?.((localCompletion) => {
          newLocalCompletions[localCompletion.id] = localCompletion;
        });
        // Alert.alert(data?.localCompletions);
        dispatch(setLocalCompletions(newLocalCompletions));
        dispatch(setLocalCompletionsList(data?.localCompletions));
      }
      // Alert.alert(JSON.stringify(data?.locationTagTypes));
    }

    if (data?.questions) {
      const newQuestions = {};
      data?.questions?.map?.((questions) => {
        const newQuestion = {...questions};
        newQuestions[newQuestion.challenge_id] = newQuestion;
      });
      console.log('setting local challenges', {
        newQuestionsLength: data?.questions?.length,
      });
      dispatch(setLocalChallenges(newQuestions));
    }
  }, [JSON.stringify(data || {})]);

  useEffect(() => {
    let newLocalLocationsList = orderLocationListByDistanceAway(
      Object.values(localLocations || {}),
      roundedLat,
      roundedLong,
    );

    console.log({localFilters});

    if (localFilters?.hasTitleFilter) {
      const titleFilter = localFilters?.title?.toLowerCase();
      newLocalLocationsList = newLocalLocationsList.filter((location) => {
        return (
          location?.title?.toLowerCase()?.includes(titleFilter) ||
          location?.guide_description?.toLowerCase()?.includes(titleFilter) ||
          location?.address?.toLowerCase()?.includes(titleFilter)
        );
      });
    }

    if (localFilters?.hasStarFilter) {
      newLocalLocationsList = newLocalLocationsList.filter((location) => {
        let match = 0;

        localFilters.star_ratings?.map?.((star_rating) => {
          console.log({star_rating, locationRating: location.rating});
          if (location.rating == star_rating) {
            match = 1;
          }
        });
        return match;
      });
    }

    if (localFilters?.hasTagFilter) {
      newLocalLocationsList = newLocalLocationsList.filter((location) => {
        let match = 1;

        localFilters.tag_ids?.map?.((tag_id) => {
          // console.log({star_rating, locationRating: location.rating});
          if (!location.tag_ids?.includes(tag_id)) {
            match = 0;
          }
        });
        return match;
      });
    }

    console.log('newLocalLocationsList loaded');

    // Alert.alert(JSON.stringify(newLocalLocationsListWithDistance));
    dispatch(setLocalLocationsList(newLocalLocationsList));
  }, [
    roundedLat,
    roundedLong,
    JSON.stringify(localLocations),
    JSON.stringify(localFilters),
  ]);

  return <View style={{}}></View>;
};

export default LocalController;
